import { store } from '..';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { notifications } from '@mantine/notifications';

import { checkAuthAction } from '@/store/api-actions/renew-auth';
import { setPasses } from '@/store/user-process/user-process';

import { ApiRoutes, baseUrl } from '@/constant/api';

import { PersonPassesResponseType } from '@/types/person';

import useUserStore from '@/shared/store/user.store.ts';

import { resetAuth } from '@/utils/resetAuth';

const fetchPasses = (token: string, personId: number | string) =>
	fetch(`${baseUrl}${ApiRoutes.Persons}/${personId}/pass`, {
		method: 'GET',
		headers: { Authorization: `Bearer ${token}` },
	});

export const getPassesAction = createAsyncThunk('user/getPasses', async () => {
	try {
		const personId = store.getState().user.user?.user.person_id;
		let token = store.getState().user.user?.access_token;

		if (!token || !personId || !baseUrl) {
			return;
		}

		let response = await fetchPasses(token, personId);

		// Токен мог истечь, пока приложение было закрыто, — продлеваем сессию и повторяем запрос
		if (response.status === 401) {
			await store.dispatch(checkAuthAction());

			token = store.getState().user.user?.access_token;
			if (!token) {
				return;
			}

			response = await fetchPasses(token, personId);
		}

		// Разовый сбой (в т.ч. сохранившийся 401) не разлогиниваем — просто не обновляем пропуска
		if (!response.ok) {
			return;
		}

		const passes = (await response.json()) as PersonPassesResponseType;

		store.dispatch(setPasses(passes.objects));
		useUserStore.getState().setPasses(passes.objects);
		localStorage.setItem('passes', JSON.stringify(passes.objects));
	} catch (error) {
		resetAuth();
		notifications.show({
			message: 'Не удалось получить список пропусков. Обратитесь в поддержку.',
			bg: '#ff0000',
			mah: '100%',
			maw: 'fit-content',
			mx: 'auto',
			radius: 12,
			autoClose: 5000,
			withCloseButton: false,
		});
	}
});
